import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Text } from '@fluentui/react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getRevenueTypeInfoStyles } from './goal-revenue-form-styles';


export const RevenueTypeInfo = (props) => {
  const { revenueType } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getRevenueTypeInfoStyles);

  const info = useMemo(() => {
    if (revenueType === 'FixedValue') {
      return (
        <div>
          <ul className={classes.infoList}>
            <li className="info">{i18n.getString(_TL_('If you only want to track your leads, enter an average number for each lead.'))}</li>
            <li className="info">{i18n.getString(_TL_('If you only sell one type of product, you can use the price of that product as the value of each conversion.'))}</li>
          </ul>
        </div>);
    }
    if (revenueType === 'VariantValue') {
      return (
        <div>
          <Text className="sub-title" styles={{ root: { color: '#72716f' } }} variant="xSmall">
            {i18n.getString(_TL_('*For this revenue type, you will need to install an additional tag code.'))}
          </Text>
          <ul className={classes.infoList}>
            <li className="info">{i18n.getString(_TL_('If you sell multiple products at different price, your conversion value can be varied based on which item is sold.'))}</li>
          </ul>
        </div>);
    }
    return null;
  }, [i18n, revenueType, classes]);

  if (info) {
    return (
      <div className={classNames('revenue-type-info', classes.infoContainer)}>
        <Text className="title" styles={{ root: { fontWeight: 600 } }} variant="medium">{i18n.getString(_TL_('This revenue type is best for:'))}</Text>
        {info}
      </div>
    );
  }
  return null;
};

RevenueTypeInfo.propTypes = {
  revenueType: PropTypes.oneOf(['FixedValue', 'VariantValue', 'NoValue']),
};
RevenueTypeInfo.defaultProps = {
  revenueType: null,
};
